import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "fluid", "fluidContent", "icon", "iconPosition", "loading", "onClick", "size", "squared", "templateId", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { cloneElement } from 'react';
import classnames from 'classnames';
import { Button as BootstrapButton, Spinner } from 'react-bootstrap';
import { useTemplateOpener } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      fluid = _ref.fluid,
      fluidContent = _ref.fluidContent,
      icon = _ref.icon,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'end' : _ref$iconPosition,
      loading = _ref.loading,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      squared = _ref.squared,
      templateId = _ref.templateId,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTemplateOpener = useTemplateOpener(),
      setTemplateId = _useTemplateOpener.setTemplateId;
  /**
   * If `templateId` is specified, we will take over the
   * click handler in order to trigger the account picker
   */


  var handleOnClick = function handleOnClick(e) {
    if (templateId) {
      setTemplateId(templateId);
      return;
    }

    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  var isLinkButton = variant === 'link';
  var isIconButton = icon && !children;
  /**
   * Renders the icon element with the class name or react element content
   */

  var getIconElement = function getIconElement() {
    /*
     * The icon is kind of type safe against string when rendering component as icon="some".
     * But since React.ReactElement is derived from string class it behaves differently in different situations,
     * hence this check is added here for safety otherwise cloneElement will throw an error with string
     */
    if (!icon || typeof icon === 'string') {
      return null;
    }

    return /*#__PURE__*/_jsx("span", {
      className: classnames('d-flex', {
        'me-50': !isIconButton && iconPosition === 'start',
        'ms-50': !isIconButton && iconPosition === 'end'
      }),
      "data-icon": true,
      children: /*#__PURE__*/cloneElement(icon, {
        size: size == 'sm' ? 200 : 300
      })
    });
  };

  return /*#__PURE__*/_jsx(BootstrapButton, _objectSpread(_objectSpread({
    className: classnames(className, 'd-inline-flex', 'align-items-center', (_classnames = {}, _defineProperty(_classnames, "btn-".concat(size), size), _defineProperty(_classnames, "btn-".concat(variant), variant), _defineProperty(_classnames, 'btn-fluid', fluid), _defineProperty(_classnames, 'btn-icon', !children), _defineProperty(_classnames, 'btn-squared', squared), _defineProperty(_classnames, 'btn-loading', loading), _defineProperty(_classnames, 'start-icon', icon && iconPosition === 'start'), _defineProperty(_classnames, 'end-icon', icon && iconPosition === 'end'), _defineProperty(_classnames, 'p-100', !isLinkButton && isIconButton && size !== 'lg'), _defineProperty(_classnames, 'p-150', !isLinkButton && isIconButton && size === 'lg'), _classnames)),
    ref: ref,
    onClick: handleOnClick
    /**
     * We handle variant through the classnames and we want to avoid react-bootstrap setting the default
     */
    ,
    variant: ""
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: classnames('d-flex align-items-center', {
        /**
         * Controls if the button content will be full width or not
         * when the button is in fluid mode
         */
        'w-100 justify-content-between': fluidContent,
        'justify-content-center': !fluidContent
      }),
      children: [getIconElement(), size === 'sm' ? /*#__PURE__*/_jsx("small", {
        children: children
      }) : children, loading && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Spinner, {
          size: size === 'sm' ? 'sm' : undefined
        }), /*#__PURE__*/_jsx("span", {
          className: "visually-hidden",
          children: "Loading"
        })]
      })]
    })
  }));
});
export default Button;